import(/* webpackMode: "eager", webpackExports: ["DashboardGuard"] */ "/vercel/path0/frontend/components/layout/DashboardGuard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/components/layout/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/components/layout/RightPanel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/components/layout/Sidebar.tsx");
